import { PaymentMethodType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { ProductSelectOption } from '@/components/modules/PricingCreate/types/ProductSelectOption';
import { ProgramSelectOption } from '@/components/modules/PricingCreate/types/ProgramSelectOption';
import { requiredEnum, requiredString } from '@/utils/zodUtils';

export const PricingDataFormSchema = (t) =>
  z
    .object({
      name: requiredString(t),
      description: requiredString(t),
      program: requiredEnum(ProgramSelectOption, t),
      product: requiredEnum(ProductSelectOption, t),
      paymentMethodType: requiredEnum(PaymentMethodType, t),
    })
    .strict();

export type PricingDataFormType = z.infer<ReturnType<typeof PricingDataFormSchema>>;
